// function that sorts by type
// func returns sort func
export const sortByProperty =
  (property: string | null, mutator = (val) => val) =>
  (a, b) => {
    if (typeof mutator(property ? a[property] : a) === 'string') {
      return mutator(property ? a[property] : a).localeCompare(
        mutator(property ? b[property] : b),
        undefined,
        {
          ignorePunctuation: true,
        }
      );
    }
    return (
      Number(mutator(property ? a[property] : a)) -
      Number(mutator(property ? b[property] : b))
    );
  };
